module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'active': _vm.active
    },
    attrs: {
      "id": "submit-overlay"
    }
  }, [_c('a', {
    staticClass: "closeBtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeSubPanel()
      }
    }
  }, [_c('img', {
    staticClass: "close-btn",
    attrs: {
      "src": require("../assets/times-bk.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2844e096"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submit.vue
// module id = 437
// module chunks = 1